export default __webpack_public_path__ + "static/media/Bastian Solutions.73e85006.png";